export const NO_SUB_CATEGORIES_POSTFIX = '-no-sub';
